export default "__VITE_ASSET__CQd7$Ifd__"